import { useAI } from "../../providers/AIProvider";
import { AIDrawer } from "../ai/AIDrawer";


export function DashboardAskAI() {
  const { addMessage, messageList } = useAI();

  return (
    <>
      <div
        style={{
          minWidth: "100%",
          width: "100%",
          height: "100%",
        }}
      >
        <AIDrawer
          addMessage={addMessage}
          updateMessage={() => {}}
          messageList={messageList}
          preview
        />
      </div>
      {/* <Flex
        className="gradient-border"
        align="center"
        justify="center"
        style={{
          width: "100%",
          marginBottom: token.marginMD,
          cursor: "pointer",
        }}
        onClick={() => {
          setUseAI(true);
        }}
      >
        <Flex
          align="center"
          justify="space-between"
          style={{
            margin: "1px 1px 2px 1px",
            width: "100%",
            borderRadius: token.borderRadiusLG,
            backgroundColor: token.colorBgContainer,
            padding: `26px 44px`,
          }}
        >
          <Text
            style={{
              fontSize: token.fontSize,
              lineHeight: token.lineHeight,
              color: token.colorText,
            }}
          >
            Let&apos;s add <br />
            <b>Another event</b>
          </Text>
          <img
            src="/assets/icon-light.svg"
            style={{
              width: "65px",
              minWidth: "65px",
              height: "65px",
              objectFit: "cover",
            }}
          />
        </Flex>
      </Flex> */}
    </>
  );
}
